import { Box, Card, Container } from "@material-ui/core";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import React, { useState } from "react";

import EventButton from "../../components/EventButton";
import EventEntityDrawer from "../../components/EventEntityDrawer";
import EventEntityTable from "../../components/EventEntityTable";
import EventSectionTitle from "../../components/EventSectionTitle";
import ModalValidation from "../../components/ModalValidate";
// ...
import Page from "../../components/Page";
import useEmails from "../../hooks/useEmails";
import AddEmail from "./components/AddEmail";
import EmailCategory from "./components/Category";
import { TABLE_HEAD } from "./config";

const EventEmail = () => {
  const isMobile = useMediaQuery("(max-width:850px)");
  const [delModal, setDelModal] = useState({
    open: false,
    id: null,
    label: "",
  });
  // ...
  const { isLoading, data: emails, onUpdate, onRemove } = useEmails();
  // ...
  const [drawer, setDrawer] = useState({ open: false, data: {}, idx: "" });
  // ...
  const emailsList = emails.map((e) => ({
    ...e,
    categoryLabel: <EmailCategory val={e.category} />,
  }));
  // ...
  const onEditEmail = async (data, idx) => {
    await onUpdate(data);
    setDrawer({ open: false, data: {}, idx: "" });
  };
  const onDeleteEmail = (id) => {
    onRemove(id);
    // ...
    setDelModal({ open: false, id: null, label: "" });
  };
  // ...
  return (
    <Page title="Manage Emails">
      <Container>
        <Box>
          <EventSectionTitle
            title="Email template"
            subTitle="Create email templates"
            src="/static/setup/title/email.svg"
          />

          <EventSectionTitle title="View templates" subTitle="View templates">
            <EventButton
              isLoading={isLoading}
              handler={() => setDrawer({ open: true, _id: null })}
            >
              {isMobile && "New"}
              {!isMobile && "New template"}
            </EventButton>
          </EventSectionTitle>

          <Box>
            <Card>
              <EventEntityTable
                label="email"
                head={TABLE_HEAD}
                data={emailsList}
                onEditHandler={(data, idx) =>
                  setDrawer({ open: true, data, idx })
                }
                onDeleteHandler={(data) => {
                  setDelModal({
                    open: true,
                    id: data.id,
                    label: data?.name,
                  });
                }}
              />
            </Card>
          </Box>
        </Box>

        <EventEntityDrawer
          open={drawer.open}
          closeDrawer={() => setDrawer({ open: false, data: {}, idx: "" })}
          title="Create email templates"
          sub="Send customized emails to your stakholders."
          width="600px"
          innerSX={{ padding: "0" }}
          headerSX={{ padding: "50px 24px 50px 24px" }}
          contentSX={{ padding: "0" }}
        >
          <AddEmail
            idx={drawer.idx}
            data={drawer.data}
            onEditEmail={onEditEmail}
            isLoading={isLoading}
          />
        </EventEntityDrawer>
      </Container>

      <ModalValidation
        open={delModal.open}
        title="Delete sponsor"
        isLoading={isLoading}
        // ...
        yes={{
          label: "delete",
          handler: () => onDeleteEmail(delModal.id),
        }}
        no={{
          label: "cancel",
          handler: () => setDelModal({ open: false, id: null, label: "" }),
        }}
      >
        Are you sure to delete email template?
      </ModalValidation>
    </Page>
  );
};

export default EventEmail;
